/* eslint-disable no-unused-vars */
import { Colors } from '../../CardWidget'

export type ChartLineOptions = {
  chart: {
    id: string
  },
  xaxis: {
    categories: string[]
  },
  stroke?: any
}

export type ChartLineSeries = {
  name: string,
  data: number[]
}

export const greenColors: string[] = ['#004811', '#1EC49A', '#00662B', '#06BAB2', '#36CD88', '#8CE688', '#B6EDA3']
export const labelGreenColors: string[] = ['#4B4B4B']

export const redColors: string[] = ['#802F5D', '#EF6167', '#DF8954', '#F37491', '#F9DDFF', '#EF6167', '#CF48AC', '#DF548B']
export const labelRedColors: string[] = ['#ffffff']

export const blueColors: string[] = ['#0F1F1C', '#162D2D', '#2D4054', '#435C67', '#59767A', '#698A72', '#859F96', '#B2C3B6']
export const labelBlueColors: string[] = ['#ffffff', '#ffffff', '#ffffff', '#ffffff']

export const greyColors: string[] = ['#000000', '#858585', '#5F5F5F', '#2E2E2E', '#474747', '#AAAAAA', '#8E8E8E', '#D0D0D0']
export const labelGreyColors: string[] = ['#ffffff']

export const orangeColors: string[] = ['#FF922B', '#E37B00', '#FFC888', '#FF9F40']
export const labelOrangeColors: string[] = ['#ffffff', '#ffffff', '#ffffff', '#ffffff']

export const rainbowColors: string[] = ['#dee2ff', '#4cc9f0', '#f72585', '#023047', '#24842C', '#d62828', '#FFB703', '#ffc8dd', '#70e000', '#540b0e']
export const labelRainbowColors: string[] = ['#000214', '#020F13', '#140109', '#ffffff', '#ffffff', '#ffffff', '#291D00', '#3D0017', '#0A1400', '#FADBDC']

export const multiColors: string[] = ['#26A0FC', '#26E7A6', '#8B75D7', '#FEBC3B', '#FF6178']
export const labelMultiColors: string[] = ['#070707', '#070707', '#02011B', '#070707', '#050506']

export const multipleShoppingCartColors: string[] = [Colors.grey, Colors.blue, Colors.green]
export const labelMultipleShoppingCartColors: string[] = [Colors.grey, Colors.blue, Colors.green]

export const twoColors: string[] = ['#ff9999', '#54EBD0']
export const labelTwoColors: string[] = ['#166974', '#791717']

export const threeColors: string[] = ['#bdebf1', '#ff9999', '#54EBD0']
export const labelThreeColors: string[] = ['#166974', '#791717', '#0f7764']

export const twoReverse: string[] = ['#54EBD0', '#ff9999']
export const labelTwoReverse: string[] = ['#0B180C', '#180000']

export enum ChartLineThemes {
  default = 'green',
  green = 'green',
  red = 'red',
  blue = 'blue',
  grey = 'grey',
  orange = 'orange',
  rainbow = 'rainbow',
  twocolors = 'twocolors',
  tworeverse = 'tworeverse',
  threecolors = 'threecolors',
  multi = 'multi',
  multipleShoppingCart = 'multipleShoppingCart'
}

export type ChartLineTheme = {
  [ChartLineThemes.default]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartLineThemes.green]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartLineThemes.red]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartLineThemes.blue]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartLineThemes.grey]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartLineThemes.orange]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartLineThemes.rainbow]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartLineThemes.twocolors]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartLineThemes.tworeverse]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartLineThemes.threecolors]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartLineThemes.multi]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartLineThemes.multipleShoppingCart]: {
    seriesColors: string[]
    labelsColors: string[]
  }
}

export const themes: ChartLineTheme = {
  [ChartLineThemes.default]: {
    seriesColors: greenColors,
    labelsColors: labelGreenColors
  },
  [ChartLineThemes.green]: {
    seriesColors: greenColors,
    labelsColors: labelGreenColors
  },
  [ChartLineThemes.red]: {
    seriesColors: redColors,
    labelsColors: labelRedColors
  },
  [ChartLineThemes.blue]: {
    seriesColors: blueColors,
    labelsColors: labelBlueColors
  },
  [ChartLineThemes.grey]: {
    seriesColors: greyColors,
    labelsColors: labelGreyColors
  },
  [ChartLineThemes.orange]: {
    seriesColors: orangeColors,
    labelsColors: labelOrangeColors
  },
  [ChartLineThemes.rainbow]: {
    seriesColors: rainbowColors,
    labelsColors: labelRainbowColors
  },
  [ChartLineThemes.twocolors]: {
    seriesColors: twoColors,
    labelsColors: labelTwoColors
  },
  [ChartLineThemes.tworeverse]: {
    seriesColors: twoReverse,
    labelsColors: labelTwoReverse
  },
  [ChartLineThemes.threecolors]: {
    seriesColors: threeColors,
    labelsColors: labelThreeColors
  },
  [ChartLineThemes.multi]: {
    seriesColors: multiColors,
    labelsColors: labelMultiColors
  },
  [ChartLineThemes.multipleShoppingCart]: {
    seriesColors: multipleShoppingCartColors,
    labelsColors: labelMultipleShoppingCartColors
  }
}
